// Types
import { SocialMediaType } from 'api/graphql-global-types';
import type { SocialAccount } from './AdminCreateUserForm';
// Helpers
import {
  getSocialProfileLinkError,
  getSocialProfileLinkExample,
} from 'helpers/socialMediaLink';

export const getSocialLinkInputError = (
  platform: SocialMediaType | undefined,
  link: string
): string | undefined => {
  if (!platform) {
    return 'Please select a platform.';
  }

  const trimmed = link.trim();
  if (!trimmed) {
    return 'Please enter your profile URL.';
  }

  // A space inside the link survives URL parsing (it becomes %20) and would be stored.
  if (/\s/.test(trimmed)) {
    return `Enter a link to your profile, e.g. ${getSocialProfileLinkExample(
      platform
    )}`;
  }

  return getSocialProfileLinkError(platform, trimmed);
};

// A blank draft row is ignored; anything typed must be valid and added, or it would be dropped
export const getSocialAccountError = ({
  platform,
  link,
  isAdded,
}: SocialAccount): string | undefined => {
  if (!isAdded && !link.trim()) {
    return undefined;
  }

  return (
    getSocialLinkInputError(platform, link) ??
    (isAdded ? undefined : 'Click Add to keep this link, or remove it.')
  );
};
